import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { RMS_ALARM_ID_FETCH_SUCCESS } from "../../Reducer/rmsAlarmIdSlice";
import Agent from "../../Network/Agent";
import CountdownTimer from "../../Props/CountdownTimer";
import { RMS_ACTIVE_HISTORY_FETCH_START } from "../../Reducer/RmsActiveAlarmHistorySlice";
import API from "../../Network/API";
import { RECTIFIER_ACTIVE_ALARM_FETCH_START, RECTIFIER_ALARM_FETCH_START } from "../../Reducer/RectifierAlarmSlice";
import { toast } from "react-hot-toast";

export default function RectifierActiveAlarm() {
    const ddd = useParams();
    const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type');
    const dispatch = useDispatch()
    const [page, setPage] = useState(1);
    const selector_rectifier_alarm = useSelector((state) => state.rectifierAlarmReducer)
    const alarm_count = selector_rectifier_alarm?.alarm_count;

    const rmsActiveAlarm = selector_rectifier_alarm
    const tenants = useSelector((state) => state.tenantReducer)
    const [site_id, setSiteId] = useState('');
    const [tenant_id, setTenantId] = useState('');
    const [loading_export, setLoadingExport] = useState(false);

    const navigate = useNavigate();

    const handleClick = (link) => {
        if (link) {
            navigate(link);
        }
    };

    const array_data = {
            'site_id': site_id,
            'alarm_type': type,
            'tenant_id': tenant_id,
            'from_date': '',
            'to_date': '',
            'page': page,
        }


    const copyToClipboard = (s_data) => {
        // Manually construct the text with line breaks between fields
        const formattedText = `
              Site ID: ${s_data.site_id}
              Operator Site ID: ${s_data.easi_site_id}
              Tenant: ${s_data.tenant_name}
              Alarm Name: ${s_data.name}
              Alarm Time: ${s_data.alarm_start}
            `;

        // Create a temporary textarea element to copy the formatted text
        const textArea = document.createElement('textarea');
        textArea.value = formattedText;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        alert('Copied to clipboard!');
    };

    const handleExport = async (e) => {
        e.preventDefault();
        if (loading_export) return;
        setLoadingExport(true);
        const toastId = toast.loading("Exporting CSV...");
        try {
            const response = await Agent.RMS_ALARM.rectifier_live_alarm_export({
                site_id,
                tenant_id,
                alarm_type: type,
            });
            const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = 'rectifier_active_alarms.csv';
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(downloadLink.href);
            toast.success("CSV downloaded", { id: toastId });
        } catch (error) {
            toast.error("Export failed", { id: toastId });
        } finally {
            setLoadingExport(false);
        }
    };

    const prevFilterKey = useRef(`${type}|${site_id}|${tenant_id}`);

    useEffect(() => {
        Agent.RMS_ALARM.rectifier_alarm_nav(dispatch);
        Agent.RMS_ALARM.rectifier_alarm_count(dispatch);
    }, [type]);

    useEffect(() => {
        const filterKey = `${type}|${site_id}|${tenant_id}`;
        const filtersChanged = prevFilterKey.current !== filterKey;
        prevFilterKey.current = filterKey;

        if (filtersChanged && page !== 1) {
            setPage(1);
            return;
        }

        const loadMore = page !== 1;
        if (!loadMore) {
            dispatch(RECTIFIER_ACTIVE_ALARM_FETCH_START());
        }
        Agent.RMS_ALARM.rectifier_live_alarm(dispatch, array_data, loadMore);
    }, [type, page, site_id, tenant_id]);

    const searchSite = (q) => {
        setPage(1)
        setSiteId(q);
    }

    const searchTenant = (q) => {
        setPage(1)
        setTenantId(q);
    }


    const observer = useRef();
    const lastElementRef = useCallback((element) => {
        //element is the react element being referenced

        // disconnect observer set on previous last element
        if (observer.current) observer.current.disconnect();

        // if there's no more data to be fetched, don't set new observer
        if (!rmsActiveAlarm?.active_data.has_more_page) return;

        // set new observer
        observer.current = new IntersectionObserver((entries) => {
            // increase page number when element enters (is intersecting with) viewport.
            // This triggers the pagination hook to fetch more items in the new page
            if (entries[0].isIntersecting && rmsActiveAlarm?.active_data.has_more_page) setPage((prev) => prev + 1);
        });

        // observe/monitor last element
        if (element) observer.current.observe(element);
    }, [rmsActiveAlarm?.active_data.has_more_page]);
    return (
        <>
            <div className="row g-2 mt-2 mb-2">
                <div className="col-md-3">
                    <div className="scroll-side-rms">

                        <table className="table table-borderless">

                            <>
                                <tr className="bg-dark text-white">
                                    <th className="p-2" colSpan={2}>Alarm Types</th>
                                </tr>

                                <tr >
                                    <td onClick={() => handleClick(`/rectifier_live_alarm?type=1`)} style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }} className="p-1 clickable">
                                        <label className="form-check-label " htmlFor={`flexCheckDefaultRms1`}>
                                            Mains Fail
                                        </label>
                                    </td>
                                    <td style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }}>
                                        <span style={{ padding: '8px' }} className={`badge ${alarm_count?.length > 0 && alarm_count[0]?.mains_fail ? 'badge-secondary-red' : 'badge-success'}  rounded-pill`}>{alarm_count?.length > 0 ? alarm_count[0]?.mains_fail : 0}</span>
                                    </td>
                                </tr>
                                   <tr >
                                    <td onClick={() => handleClick(`/rectifier_live_alarm?type=5`)} style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }} className="p-1 clickable">
                                        <label className="form-check-label " htmlFor={`flexCheckDefaultRms1`}>
                                            DC Low
                                        </label>
                                    </td>
                                    <td style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }}>
                                        <span style={{ padding: '8px' }} className={`badge ${alarm_count?.length > 0 && alarm_count[0]?.dc_low ? 'badge-secondary-red' : 'badge-success'}  rounded-pill`}>{alarm_count?.length > 0 ? alarm_count[0]?.dc_low : 0}</span>
                                    </td>
                                </tr>
       <tr >
                                    <td onClick={() => handleClick(`/rectifier_live_alarm?type=2`)} style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }} className="p-1 clickable">
                                        <label className="form-check-label " htmlFor={`flexCheckDefaultRms1`}>
                                            Module Fault
                                        </label>
                                    </td>
                                    <td style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }}>
                                        <span style={{ padding: '8px' }} className={`badge ${alarm_count?.length > 0 && alarm_count[0]?.module_fault ? 'badge-secondary-red' : 'badge-success'}  rounded-pill`}>{alarm_count?.length > 0 ? alarm_count[0]?.module_fault : 0}</span>
                                    </td>
                                </tr>
                                       <tr >
                                    <td onClick={() => handleClick(`/rectifier_live_alarm?type=6`)} style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }} className="p-1 clickable">
                                        <label className="form-check-label " htmlFor={`flexCheckDefaultRms1`}>
                                            Fuse Fault
                                        </label>
                                    </td>
                                    <td style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }}>
                                        <span style={{ padding: '8px' }} className={`badge ${alarm_count?.length > 0 && alarm_count[0]?.fuse_fault ? 'badge-secondary-red' : 'badge-success'}  rounded-pill`}>{alarm_count?.length > 0 ? alarm_count[0]?.fuse_fault : 0}</span>
                                    </td>
                                </tr>
                                       <tr >
                                    <td onClick={() => handleClick(`/rectifier_live_alarm?type=3`)} style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }} className="p-1 clickable">
                                        <label className="form-check-label " htmlFor={`flexCheckDefaultRms1`}>
                                            LLVD
                                        </label>
                                    </td>
                                    <td style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }}>
                                        <span style={{ padding: '8px' }} className={`badge ${alarm_count?.length > 0 && alarm_count[0]?.llvd ? 'badge-secondary-red' : 'badge-success'}  rounded-pill`}>{alarm_count?.length > 0 ? alarm_count[0]?.llvd : 0}</span>
                                    </td>
                                </tr>
                                       <tr >
                                    <td onClick={() => handleClick(`/rectifier_live_alarm?type=4`)} style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }} className="p-1 clickable">
                                        <label className="form-check-label " htmlFor={`flexCheckDefaultRms1`}>
                                            BLVD
                                        </label>
                                    </td>
                                    <td style={{ borderBottom: '0.5px solid #000', fontSize: '14px' }}>
                                        <span style={{ padding: '8px' }} className={`badge ${alarm_count?.length > 0 && alarm_count[0]?.blvd ? 'badge-secondary-red' : 'badge-success'}  rounded-pill`}>{alarm_count?.length > 0 ? alarm_count[0]?.blvd : 0}</span>
                                    </td>
                                </tr>
                                   

                            </>

                        </table>

                    </div>
                </div>
                <div className="col-md-9">

                    {/* // title and filter tenant and site with export */}
                    <div className="row g-2 mb-2">

                        <div className="col-md-8">
                            <h6 className="m-0 p-0">Total Alarms: {rmsActiveAlarm?.active_data?.total_page}</h6>
                            <p className="p-0 m-0 fs-12">Current Display 1 - {rmsActiveAlarm?.active_alarms?.length} Record(s), {rmsActiveAlarm?.active_data?.total_page} Record(s) Totally</p>

                        </div>
                        <div className="col-md-4 text-end">

                            <div className="input-group input-group-sm">
                                <input type="text" onKeyUp={(e) => searchSite(e.target.value)} className="form-control form-control-sm" placeholder="Search by site id...." aria-label="Search" aria-describedby="basic-addon1" />
                                <select onChange={(e) => searchTenant(e.target.value)} className="form-select form-select-sm" aria-label=".form-select-sm example">
                                    <option value="">All Tenants</option>
                                    {tenants?.data?.length > 0 && tenants?.data?.map((tenant, indexI) => (
                                        <option value={tenant.id}>{tenant.name}</option>
                                    ))}

                                </select>
                                <a href="#" onClick={(e) => handleExport(e)} class="input-group-text btn btn-sm btn-info" id="basic-addon2"> <i className="fa-light fa-file-excel"></i> Export {loading_export ? (
                                    <span
                                        className="spinner-border spinner-border-sm ms-2"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                ) : (
                                    <span></span>
                                )}</a>
                            </div>


                        </div>
                    </div>




                    <div className="table-responsive custom-table-responsive scroll-side-rms-active">
                        <table className="table custom-table text-center ">
                            <tbody>
                                <>
                                    {rmsActiveAlarm?.active_loading ? <p>Loading......</p> : ''}
                                </>

                                {!rmsActiveAlarm?.active_loading && rmsActiveAlarm?.active_alarms?.map((alarm, index) => (

                                    <>
                                        <tr className="bg-white" ref={index === rmsActiveAlarm?.active_alarms.length - 1 ? lastElementRef : undefined}>
                                            <td>
                                                <i onClick={() => copyToClipboard(alarm)} className="fa fa-copy text-success" style={{ fontSize: '20px', cursor: 'pointer' }} />

                                            </td>
                                            <td width="7%">
                                                <div className="signal-bars mt1 sizing-box good four-bars">
                                                    <span>
                                                        <img src="/assets/icon/6.svg" className="tower-height" alt="" />
                                                    </span>
                                                    <div className={`first-bar bar ${alarm.network >= 1 ? '' : 'null-color'}`}>
                                                    </div>
                                                    <div className={`second-bar bar ${alarm.network >= 2 ? '' : 'null-color'}`}>
                                                    </div>
                                                    <div className={`third-bar bar ${alarm.network >= 3 ? '' : 'null-color'}`}>
                                                    </div>
                                                    <div className={`fourth-bar bar ${alarm.network >= 4 ? '' : 'null-color'}`}>
                                                    </div>
                                                    <div className={`fifth-bar bar ${alarm.network >= 5 ? '' : 'null-color'}`}>
                                                    </div>
                                                </div>
                                            </td>
                                            <td width="6%" className="status" rel={alarm.id} data-value={alarm.site_id}>
                                                <p className="tr-header">SITE ID</p>
                                                <p className="tr-header-sub fw-bold"><Link to={`/site/${alarm.site_id}`}>{alarm.site_id}</Link>
                                                </p>
                                            </td>
                                            <td width="12%">
                                                <p className="tr-header">Tenant</p>
                                                <p className="tr-header-sub ">{alarm.tenant_name}</p>
                                            </td>
                                            <td width="10%" >
                                                <p className="tr-header">Operator Site</p>
                                                <p className="tr-header-sub fw-bold"><Link to={`/site/${alarm.site_id}`}>{alarm.easi_site_id}</Link></p>
                                            </td>
                                            <td width="25%">
                                                <p className="tr-header">Alarm Name</p>
                                                <p className="tr-header-sub">
                                                    {alarm.name}
                                                </p>
                                            </td>
                                            <td width="15%">
                                                <p className="tr-header">Alarm Time</p>
                                                <p className="tr-header-date">
                                                    {alarm.alarm_start}

                                                </p>
                                            </td>

                                            <td width="20%" className="elisp_time">
                                                <p className="tr-header">Elapsed Time</p>
                                                <p className="tr-header-sub elisp_time">
                                                    {alarm.alarm_end != null ?
                                                        <span className="elisp_time">{alarm.total_elaspsed}</span>
                                                        :
                                                        <CountdownTimer targetDate={alarm.start} />
                                                    }


                                                </p>
                                            </td>
                                        </tr>
                                        <tr className="spacer"><td colSpan={100} /></tr>
                                    </>

                                ))}
                            </tbody>
                        </table>

                        {rmsActiveAlarm?.active_loading && <div className="text-center">Loading......</div>}

                    </div>
                    <p className="p-0 m-0 fs-12">Current Display 1 - {rmsActiveAlarm?.active_alarms?.length} Record(s), {rmsActiveAlarm?.active_data?.total_page} Record(s) Totally</p>


                </div>
            </div>
        </>
    )
}